export default __webpack_public_path__ + "media/images/images_v2/error-bottom-f683031cbcf1cba250b73077fdcc8bd7.png";